import { useState } from "react";
import { architectureImage } from "@/data/siteData";

export default function HeroVisual() {
  const [shift, setShift] = useState({ x: 0, y: 0 });
  const [imageReady, setImageReady] = useState(true);

  const move = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setShift({
      x: ((event.clientX - rect.left) / rect.width - 0.5) * 6,
      y: ((event.clientY - rect.top) / rect.height - 0.5) * 6,
    });
  };

  return (
    <figure className="hero-art-dominant" onPointerMove={move} onPointerLeave={() => setShift({ x: 0, y: 0 })} data-testid="hero-visual">
      <div className="hero-image-frame" style={{ transform: `translate3d(${shift.x}px, ${shift.y}px, 0)` }} data-testid="hero-image-frame">
        {imageReady ? <img className="hero-editorial-image" src={architectureImage} alt="Abstract data architecture with connected analytics signals and semantic layers" width={1264} height={848} fetchPriority="high" decoding="async" data-testid="hero-image" onError={() => setImageReady(false)} /> : <div className="art-image-fallback" data-testid="hero-image-fallback">Structure before scale.</div>}
      </div>
      <figcaption className="hero-image-note" data-testid="hero-image-caption">
        <span data-testid="hero-image-kicker">EDITORIAL FIELD NOTE / 01</span>
        <span data-testid="hero-image-title">DATA ARCHITECTURE AS EVIDENCE</span>
      </figcaption>
    </figure>
  );
}
